<div class="co-lottery">
  <div class="co-lottery__row clearfix row co-lottery__header">
    <div class="co-lottery__col columns small-12 medium-6">Losanteile</div>
    <div class="co-lottery__col columns small-12 medium-6">Losanzahl</div>
  </div>
  <div
    class="co-lottery__row clearfix row"
    *ngFor="let lottery of lotteries.products"
    [ngClass]="{ 'co-lottery__row--joker': lottery.category === 'Joker' }"
    [id]="lottery.name"
  >
    <div class="co-lottery__col columns small-12 medium-6">
      <div class="co-lottery__info">
        <strong>{{ lottery.name }}</strong>
        <p *ngIf="lottery.category !== 'Joker'">
          Lospreis pro Klasse:
          {{ lottery.price | currency : 'EUR' : 'symbol' : '1.2-2' }}
        </p>
        <p *ngIf="lottery.category === 'Joker'">
          Jeden Monat 50 Renten zu gewinnen:<br />
          10 sorgenfreie Jahre dank eines gesicherten Zusatz-Einkommens. Für nur
          {{ lottery.price | currency : 'EUR' : 'symbol' : '1.2-2' }} pro Monat.
        </p>
      </div>
    </div>
    <div class="co-lottery__col columns small-12 medium-6">
      <app-ticket-select
        [product]="lottery"
        [odds]="lotteries.odds"
      ></app-ticket-select>
    </div>
  </div>
</div>
